import React from "react";
import "./Facts.css";

const Facts = ({ facts }) => {
  if (!facts || facts.length === 0) return null;

  return (
    <div className="facts-grid">
      {facts.map((fact, idx) => (
        <div key={idx} className="fact-row">
          <span className="fact-label">{fact.label}</span>
          <span className="fact-value">{fact.value}</span>
        </div>
      ))}
    </div>
  );
};

export default Facts;
